membershipApp.controller('MembershipChangePaymentMethodController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	$scope.alerting = false;
	var $translateThis = $filter('translate');
	$scope.loading = false;

	if ( lang ){
		$translate.use(lang);
	}

	$scope.getClientServices = function (clientID) {
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: clientID ? clientID : client.ClientID
		}

		$http({
			method: 'POST',
			url: '/Membership/GetClientServices',
			data: dataObject
		}).success(function (data) {
			$scope.clientServices = data;
			$scope.PaymentMethods.forEach(function (el) {
				var el = el;
				let resultServices = $.grep($scope.clientServices, function (e) { return e.PaymentMethodID == el.ID; });
				let resultMembers = $.grep($scope.clientGroupMembers, function (e) { return e.ClientID == el.OwnerClientID; });


				if (resultServices.length > 0) {
					el.ServiceName = resultServices[0].ServiceName;
					el.ClientName = resultServices[0].ClientName;
				}

				if(resultMembers.length > 0){
					el.OwnerClientName = resultMembers[0].ClientName;
				}
			});
		}).error(function () {
		});
	}

	$scope.getPaymentMethods = function (clientID) {
	    if (client != null && client != undefined) {
	        var dataObject = {
	            Namespace: namespace,
	            GymID: gymid,
	            ClientId: clientID ? clientID : client.ClientID
	        }

	        $http({
	            method: 'POST',
	            url: '/Membership/GetPaymentMethods',
	            data: dataObject
	        }).success(function (data) {
	            $scope.PaymentMethods = data;
	            $scope.getClientServices(clientID);
	        }).error(function () {
	        });
	    }
	}
	$scope.getPaymentMethods();

	$scope.selectGroupMember = function(){
		if($scope.clientGroupMemberID){
			let id = Number($scope.clientGroupMemberID);
			$scope.getPaymentMethods(id);
		}
	}

	$scope.setDefaultPaymentMethod = function (id) {
		var paymentId = id;
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: $scope.clientGroupMemberID ? Number($scope.clientGroupMemberID) : client.ClientID,
			Id: paymentId
		}

		$http({
			method: 'POST',
			url: '/Membership/SetDefaultPaymentMethod',
			data: dataObject
		}).success(function (data) {
			var data = data;
			if (data == true) {
				$('.card-item[data-paymentid="' + paymentId + '"]').addClass('default').siblings('.default').removeClass('default');
			}
		}).error(function () {
		});
	}

	$scope.removePaymentMethod = function (id) {
		$scope.loading = true;
		var paymentId = id;
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: $scope.clientGroupMemberID ? Number($scope.clientGroupMemberID) : client.ClientID,
			Id: paymentId
		}

		$http({
			method: 'POST',
			url: '/Membership/RemovePaymentMethod',
			data: dataObject
		}).success(function (data) {
			var data = data;
			$scope.loading = false;
			var translated = $translateThis('Payment method removed!');
			Swal.fire({
                type: 'warning',
                title: translated,
                onAfterClose: (function () {
					$scope.closePopup('removePaymentMethod');
                    window.location.reload(true);
                })
            })
		}).error(function (err) {
			$scope.loading = false;
			Swal.fire({
                type: 'warning',
                title: err
            })
		});
	}

	$scope.addPaymentMethodButton = function(){
		if($scope.mainPaymentWay == 'mypos'){
			createIntentFuturePayments();
		}else if ($scope.mainPaymentWay == 'netcash' || $scope.mainPaymentWay == 'netcashmandate'){
			createIntentFuturePayments();
		}else{
			$scope.addPaymentMethod();
		}
	}

	function createIntentFuturePayments(){
		$scope.loading = true;
		let lang = $translate.proposedLanguage() || $translate.use();
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: $scope.clientGroupMemberID ? Number($scope.clientGroupMemberID) : client.ClientID,
			Email: client.Email,
			OwnerClientID: client.ClientID
		}

		if ($scope.mainPaymentWay == 'mypos') {
			dataObject.MyPos = true;
			dataObject.Language = lang;
		}

		if ($scope.mainPaymentWay == 'netcash') {
			dataObject.Netcash = true;
		}

		if ($scope.mainPaymentWay == 'netcashmandate') {
			dataObject.Netcash = true;
			dataObject.RequestNetcashMandate = true;
		}

		$http({
			method: 'POST',
			url: '/Membership/CreateIntentFuturePayments',
			data: dataObject
		}).success(function (data) {

			if ($scope.mainPaymentWay == 'STRIPE CARD') {
				$scope.PaymentIntentID = data.ID;
				let secret = data.ClientSecret;
				stripe(secret);
				$scope.loading = false;
			}else if($scope.mainPaymentWay == 'mypos'){
				if(data){
					post_to_url(data, 'post');
				}

				$scope.loading = false;
			}else if($scope.mainPaymentWay == 'netcash'){

				if(data.Success){
					post_to_url(data.netCashValues, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
				}else{
					var translated = $translateThis('buyError');
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							});
						})
					});
				}
				
			}else if($scope.mainPaymentWay == 'netcashmandate'){
				if(data.Success){
					window.
					location.href = data.MandateURL;
				}else{
					var translated = $translateThis(data.Message);
					Swal.fire({
						type: 'warning',
						title: translated
					})
					$scope.loading = false;
				}
			}else{
				$scope.loading = false;
			}
		}).error(function (error) {
			// console.log('error');
		});
	}

	function post_to_url(params, method, url) {
		let path = $scope.membershipSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
		if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

	function stripe(secret){
		$('.step-actions .stripe-button').addClass('active');
		// Set your publishable key: remember to change this to your live publishable key in production
		// See your keys here: https://dashboard.stripe.com/apikeys
		const stripe = Stripe($scope.membershipSettings.StripePublishKey);

		const options = {
			clientSecret: secret,
			// Fully customizable with appearance API.
			appearance: {
				theme: 'stripe',
				variables: {
					colorPrimary: '#0570de',
					colorBackground: '#ffffff',
					colorText: '#30313d',
					colorDanger: '#df1b41',
					fontFamily: 'Ideal Sans, system-ui, sans-serif',
					spacingUnit: '2px',
					borderRadius: '4px',
					// See all possible variables below
				}
			},
		};

		
		// Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
		const elements = stripe.elements(options);
		
		// Create and mount the Payment Element
		const paymentElement = elements.create('payment');
		paymentElement.mount('#payment-element');

		$scope.loading = false

		$('.stripe-button').on('click', function(e){
			e.preventDefault();

			if ($scope.loading == false || $scope.loading == undefined) {
				$scope.loading = true;
				stripe.confirmSetup({
					//`Elements` instance that was used to create the Payment Element
					elements,
					confirmParams: {
						return_url: 'https://my-site.com/account/payments/setup-complete',
					},
					redirect: 'if_required',
				})
				.then(function(result) {
					
					if (result.error){
						// This point will only be reached if there is an immediate error when
						// confirming the payment. Show error to your customer (e.g., payment
						// details incomplete)
						const messageContainer = document.querySelector('#error-message');
						messageContainer.textContent = result.error.message;
						$scope.loading = false;
					}else{
						
						$scope.addPaymentMethod();
					}
					// Inform the customer that there was an error.
				});
			}
		})
	}

	$scope.addPaymentMethod = function (token) {
		$scope.loading = true;

		var newPaymentMethodModel = { 
			PaymentProvider: $scope.mainPaymentWay, 
			ClientID: $scope.clientGroupMemberID ? Number($scope.clientGroupMemberID) : client.ClientID, 
			CardID: client.CardID, 
			paymentIntentID: $scope.PaymentIntentID,
			OwnerClientID : client.ClientID
		}

		if ( token ) {
			if ( $scope.mainPaymentWay == 'STRIPE CARD' ) {
				token = token.id;
			}
			newPaymentMethodModel.Token = token;			
		}

		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			model: newPaymentMethodModel
		}

		$http({
			method: 'POST',
			url: '/Membership/AddPaymentMethod',
			data: dataObject
		}).success(function (data) {
			$scope.PaymentIntentID = 0;
			var data = data;
			if (data == 'error' || data == 'Error') {
				var translated = $translateThis('There was error with your purchase!');
				Swal.fire({
	                type: 'warning',
                    title: translated
	            })

			}else if(data == 'done'){
				var translated = $translateThis('Payment method added!');
				Swal.fire({
	                type: 'success',
                    title: translated,
                    onAfterClose: (function () {
                        window.location.reload(true);
                    })
	            })
			} else {
				window.location.replace(data);
			}
			$scope.loading = false;
		}).error(function () {
			$scope.PaymentIntentID = 0;
		});
	}

	$scope.cardMethod = function(id, add){

		if(add){
			var translated = $translateThis('Are you sure you want to make this payment method default');
			Swal.fire({
				type: 'warning',
				title: translated,
				showCancelButton: true,
			}).then(function(result) {
				if (result.value) {
					$scope.setDefaultPaymentMethod(id);
				}
			});
		}else{
			var translatedTitle = $translateThis('Are you sure you want to delete the payment method?');
			var translatedText = $translateThis('If you have active memberships using this payment method they cant be billed and the membership usage will be interrupted!');
			Swal.fire({
				type: 'warning',
				title: translatedTitle,
				text: translatedText,
				showCancelButton: true,
			}).then(function(result) {
				if (result.value) {
					$scope.removePaymentMethod(id);
				}
			});
		}

	}
	
	$scope.$watch('mainPaymentWay', function (v) {

		var paymentValue = v;
		$scope.paymentway = '';

		if (paymentValue == 'STRIPE CARD') {
			$scope.loading = true;

			$scope.PaymentIntentID = 0;

			createIntentFuturePayments();
		}else{
			$('.step-actions .stripe-button').removeClass('active');
		}
	});
}])